import React, { FC } from 'react';
import classNames from 'classnames';
import { ProductSelection } from '../product-selection/ProductSelectionTypes';
import { hasProductSelection } from '../product-selection/ProductSelectionUtils';
import { useTranslation } from 'react-i18next';

export type SelectButtonProps = {
    productSelection: ProductSelection;
    onClick: () => void;
    isProductSelectable: boolean;
    isProductSelected: boolean;
};

export const SelectButton: FC<SelectButtonProps> = ({
    productSelection,
    onClick,
    isProductSelectable,
    isProductSelected
}) => {
    const { t } = useTranslation();
    if (!isProductSelectable) {
        return null;
    }

    const somethingSelected = hasProductSelection(productSelection);
    const classes = classNames('icn-select', {
        selected: isProductSelected,
        'selection-mode': somethingSelected
    });
    const title = isProductSelected ? t('components.selectButton.select') : t('components.selectButton.deselect');

    return <i data-testid="select-button" className={classes} title={title} onClick={onClick} />;
};

export default SelectButton;
